/**
 * 環境設定で使用する共通定数
 */

// Sentry DSN（全環境共通）
export const SENTRY_DSN =
  'https://0e51f01796522169eae7b21d846049ef@o117937.ingest.us.sentry.io/4509689066422272';
